import { render, staticRenderFns } from "./CompetitionMain.vue?vue&type=template&id=58968a8e&scoped=true"
import script from "./CompetitionMain.vue?vue&type=script&lang=ts"
export * from "./CompetitionMain.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionMain.vue?vue&type=style&index=0&id=58968a8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58968a8e",
  null
  
)

export default component.exports